<template>
  <div class="flex flex-col">
    <div
      class="py-4 px-6 flex items-center justify-between border-b border-slate-400"
    >
      <BlTextSubtitle2 text="Share this report" class="text-slate-700" />
      <BlIcon
        icon="close"
        class="h-6 w-6"
        clickable
        @clicked="$emit('close')"
      />
    </div>
    <div class="py-4 px-6 flex flex-col gap-3">
      <BlTextBody2
        text="Your report has been successfully published! You can now share it with others via the provided link or QR code."
      />
      <div class="relative cursor-pointer" @click="onCopyToClipboard">
        <BlInputText class="pr-8 cursor-pointer" :input="linkInput" />
        <BlIcon
          icon="copy"
          color="slate-8"
          class="absolute top-2 right-4 h-6 w-6"
        />
      </div>
      <div class="py-4 flex justify-center">
        <QrcodeVue :value="linkInput.model" :size="200" level="L" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import QrcodeVue from "qrcode.vue";

import BlTextSubtitle2 from "../../BlTextSubtitle2.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlInputText from "../../BlInputText.vue";
import BlIcon from "../../BlIcon.vue";

export default {
  name: "ShareReport",
  components: {
    QrcodeVue,
    BlTextSubtitle2,
    BlTextBody2,
    BlInputText,
    BlIcon
  },
  props: {
    // @close
  },
  data() {
    return {
      linkInput: {
        placeholder: "Link",
        model: "",
        readonly: true
      }
    };
  },
  computed: {
    ...mapGetters(["report"])
  },
  watch: {},
  mounted() {
    const url = window && window.location ? window.location.href : "";
    this.linkInput.model = url;
  },
  methods: {
    ...mapActions(["showToast"]),
    onCopyToClipboard() {
      if (!this.linkInput.model) return;
      navigator.clipboard.writeText(this.linkInput.model);
      const title = "Link copied";
      const message = "Report link has been copied to clipboard.";
      this.showToast({ title, message, type: "success" });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/reports/helper/ShareReport.vue